var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 92,
    viewBox: "0 0 12 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    y1: -0.952525,
    x2: 80.9126,
    y2: -0.952525,
    transform: "matrix(1.19249e-08 1 1 -1.19249e-08 6.94214 0.737305)",
    stroke: "url(#paint0_linear_75_279)",
    strokeWidth: 1.90505
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 5.94956,
    cy: 5.94956,
    r: 4.99704,
    transform: "matrix(1 0 0 -1 0 91.7051)",
    fill: "white",
    stroke: "url(#paint1_linear_75_279)",
    strokeWidth: 1.90505
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_279",
    x1: 80.9126,
    y1: -0.00000185653,
    x2: 0,
    y2: 0.00000488109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_279",
    x1: 11.8991,
    y1: -0.0000220911,
    x2: 0,
    y2: -0.0000220789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin2);
export default __webpack_public_path__ + "static/media/join2.6dd9a87522c5d09c33351bb1efd9609f.svg";
export { ForwardRef as ReactComponent };